export const getAuthData = () => ({
  // TODO: User & pass from encamina cognitive services
  username: 'mm',
  password: 'mm',
})
